<template>
    <SelectSite
        :selectedSite="selectedSite"
        :title="title"
        :site-list-namespace="siteListNamespace"
        :regle-cle="regleCle"
        class="step-one-container"
        @pick="pick"
        @filter-change="pick(undefined)"
    />
</template>

<script lang="ts">
import SelectSite from '@/modules/SiteList/components/SelectSite.vue';
import { INTERVENTION } from '../store/mutation-types';
import { Site } from '@/models/Site';
import { defineComponent } from 'vue';
import { EquipementActions } from '../store/modules/Equipement';
import { PreavisEquipementActions } from '@/modules/PreavisIntervention/store/modules/PreavisEquipement';
import { store } from '@/plugins/store';
export default defineComponent({
    emits: ['next'],
    props: {
        title: { type: String, required: true },
        equipementNamespace: { type: String, default: 'equipementModule' },
        siteGetter: { type: String, default: 'getInterventionSiteValue' },
        siteMutation: { type: String, default: INTERVENTION.SET_SITE },
        resetToStepMutation: { type: String, default: INTERVENTION.RESET_TO_STEP },
        setEquipementMutation: { type: String, default: INTERVENTION.SET_EQUIPEMENT },
        siteListNamespace: { type: String, default: 'siteList' },
        regleCle: { type: String, required: false },
    },
    components: { SelectSite },
    computed: {
        selectedSite() {
            return store.getters[this.siteGetter];
        },
        equipementActionName(): string {
            return this.equipementNamespace === 'preavisEquipementModule'
                ? PreavisEquipementActions.GET_EQUIPEMENT
                : EquipementActions.GET_EQUIPEMENT;
        },
        listSites() {
            return store.getters[`${this.siteListNamespace}/getListValue`];
        },
    },
    methods: {
        pick(site: Site): void {
            if (site) {
                if (this.resetToStepMutation) {
                    store.commit(this.resetToStepMutation, 2);
                }
                store.commit(this.siteMutation, site);
                // Reset immédiat de la liste/chargement et des filtres/tri pour éviter le flash
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_SCROLL`, 0 as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_ITEMS`, [] as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_NUMBER_OF_PAGES`, 0 as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_PAGE`, 0 as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_LOADING`, true as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_FILTER`, '' as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_GROUPE_FILTER`, '' as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_SS_GROUPE_FILTER`, '' as any);
                store.commit(`${this.equipementNamespace}/SET_EQUIPEMENT_SORT`, {
                    sortData: 'equipementLibelle',
                    sortStatus: 0, // ASC
                } as any);
                if (this.setEquipementMutation) {
                    store.commit(this.setEquipementMutation, undefined);
                }
                store.dispatch(`${this.equipementNamespace}/${this.equipementActionName}`, {
                    adresseSiteId: site.id,
                    page: 0,
                    equipementFilter: '',
                    groupeFilter: '',
                    ssGroupeFilter: '',
                    sort: store.getters[`${this.equipementNamespace}/getSort`],
                });
            }
        },
    },
    watch: {
        //s'il n'y a qu'un site, on le selectionne et on passe à l'étape suivante
        listSites(newSites: Site[]) {
            if (newSites.length === 1) {
                this.pick(newSites[0]);
                this.$emit('next');
            }
        },
    },
});
</script>

<style scoped>
.step-one-container {
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    max-height: calc(100vh - 260px);
}
</style>
